import { useQuery } from "@tanstack/react-query";
import { Interval } from "date-fns";
import { useFilter } from "../../filters";
import { useCalendarProvider } from "../CalendarProvider";
import { calendarEventService } from "./calendarEventService";

export const useCalendarEvents = (showOnlyOwnEvents: boolean) => {
	const state = useCalendarProvider();
	const { activeFilterId } = useFilter();
	const interval: Interval = {
		start: state.startOfMonthAndWeek,
		end: state.endOfMonthAndWeek,
	};

	const { data: events = [] } = useQuery({
		queryKey: [
			...calendarEventService.calendarKey,
			activeFilterId,
			interval,
			`showOnlyOwnEvents=${showOnlyOwnEvents ? "1" : "0"}`,
		],
		queryFn: () => calendarEventService.calendar(interval, activeFilterId, showOnlyOwnEvents).then((r) => r.data.data),
	});

	return events;
};
